import { SitterProfileResponse } from 'happypaws-shared/src/Sitter/models/SitterProfileResponse';
import { UISitterDisplay } from '../types/ui.sitter.types';

export const mapSitterToDisplay = (sitter: SitterProfileResponse): UISitterDisplay | null => {
  // Skip sitters without location
  if (!sitter.lat || !sitter.lng) return null;

  const minPrice =
    sitter.pricing.length > 0 ? Math.min(...sitter.pricing.map((p) => p.priceMin)) : 0;

  return {
    id: sitter.id,
    name: `${sitter.firstName} ${sitter.lastName.charAt(0)}.`,
    rating: 0, // will come from bookings table later
    reviewCount: 0, // will come from bookings table later
    location: `${sitter.username ?? sitter.firstName}`,
    coordinates: { lat: sitter.lat, lng: sitter.lng },
    price: minPrice,
    photoUrl: sitter.profilePhotoUrl ?? sitter.photoUrl ?? '',
    reviewSnippet: sitter.bio ?? '',
    services: sitter.serviceTypes ?? [],
    hasHouse: sitter.homeEnvironment?.includes('yard-with-fence') ?? false,
    hasApartment: false,
    hasFencedYard: sitter.homeEnvironment?.includes('yard-with-fence') ?? false,
    allowsDogsOnFurniture: sitter.homeEnvironment?.includes('allowed-on-furniture') ?? false,
  };
};
